import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RequestService {

    public url = 'https://devcherish.site/';

    constructor(public http: HttpClient) { }

    get(path: string) {
        let promise = new Promise<any>((resolve, reject) => {
            let url = this.url + path;

            this.http.get(url, { headers: { 'auth-token': localStorage.getItem('token') } })
                .toPromise()
                .then(res => {
                    resolve(res);
                })
        })
        return promise;
    }

    post(path, data) {
        let promise = new Promise<any>((resolve, reject) => {
            let url = this.url + path;

            this.http.post(url, data, { headers: { 'auth-token': localStorage.getItem('token') } })
                .toPromise()
                .then(res => {
                    resolve(res);
                })
        })
        return promise;
    }

    patch(path, data) {
        let promise = new Promise<any>((resolve, reject) => {
            let url = this.url + path;

            this.http.patch(url, data, { headers: { 'auth-token': localStorage.getItem('token') } })
                .toPromise()
                .then(res => {
                    resolve(res);
                })
        })
        return promise;
    }

    delete(path) {
        let promise = new Promise<any>((resolve, reject) => {
            let url = this.url + path;

            this.http.delete(url, { headers: { 'auth-token': localStorage.getItem('token') } })
                .toPromise()
                .then(res => {
                    resolve(res);
                })
        })
        return promise;
    }
}